export default {
  awardsData: (state) => state.awardsResult?.awardsData,
  filterForm: (state) => state.awardsResult?.filterForm,
};
